function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "85.457%",
  y1: "100%",
  x2: "14.543%",
  y2: "0%",
  id: "Success_svg__5_a"
}, React.createElement("stop", {
  stopColor: "#7B8B99",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#9BADBC",
  offset: "100%"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M14 0a2 2 0 012 2v15a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h12zM5.611 9H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5H5.61a.5.5 0 00.5-.5V9.5a.5.5 0 00-.5-.5zm3.667-2.7H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5h6.222a.5.5 0 00.5-.5V6.8a.5.5 0 00-.5-.5zm3.666-2.7H3.056a.5.5 0 00-.5.5v.62a.5.5 0 00.5.5h9.888a.5.5 0 00.5-.5V4.1a.5.5 0 00-.5-.5z",
  fill: "url(#Success_svg__5_a)"
}), React.createElement("circle", {
  fill: "#FFF",
  cx: 14,
  cy: 16,
  r: 7
}), React.createElement("path", {
  d: "M14 10.667a5.333 5.333 0 015.329 5.113l.004.22a5.333 5.333 0 01-5.113 5.329l-.22.004a5.333 5.333 0 010-10.666zm2.195 2.798a.454.454 0 00-.053.059l-3.077 4.086-1.164-1.5a.504.504 0 00-.731-.061.438.438 0 00-.041.593l1.344 1.739a.759.759 0 001.005.165c.07-.045.13-.101.179-.165l3.257-4.326a.438.438 0 00-.04-.593.507.507 0 00-.68.003z",
  fill: "#1DC463"
}));

var SvgSuccess = function SvgSuccess(props) {
  return React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23"
  }, props), _ref, _ref2);
};

export default SvgSuccess;